import React from "react";

import {
  Content,
  Grid,
  GridItem,
  PageSection,
  Stack,
  StackItem
} from "@patternfly/react-core";

import {
  ProjectDocuments,
  ProjectInfoCard,
  ProjectPageHeader,
  ProjectSection
} from "apps/school-site/features/projects";

import {
  internshipSpecialistProject,
  participantDocuments,
  staffDocuments
} from "./data/internshipSpecialistProjectData";


const InternshipSpecialistProjectPage = () => {
  return (
    <PageSection isWidthLimited>
      <Stack hasGutter>
        <StackItem>
          <ProjectPageHeader
            title="Od stażysty do specjalisty"
            description="Archiwalny projekt realizowany przez szkołę."
          />
        </StackItem>

        <StackItem>
          <Grid>
            <GridItem
              span={12}
              md={10}
              mdOffset={1}
            >
              <ProjectInfoCard
                title={internshipSpecialistProject.title}
                description={internshipSpecialistProject.description}
                image={internshipSpecialistProject.image}
              >
                <Content>
                  <p>
                    <a
                      href={internshipSpecialistProject.projectInfoUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Informacje o projekcie
                    </a>
                  </p>
                </Content>
              </ProjectInfoCard>
            </GridItem>
          </Grid>
        </StackItem>

        <StackItem>
          <Grid>
            <GridItem
              span={12}
              md={10}
              mdOffset={1}
            >
              <ProjectDocuments
                title="Dokumenty dla uczestnika projektu"
                documents={participantDocuments}
              />
            </GridItem>
          </Grid>
        </StackItem>

        <StackItem>
          <Grid>
            <GridItem
              span={12}
              md={10}
              mdOffset={1}
            >
              <ProjectDocuments
                title="Dokumenty dla personelu projektu"
                documents={staffDocuments}
              />
            </GridItem>
          </Grid>
        </StackItem>
      </Stack>
    </PageSection>
  );
};

export default InternshipSpecialistProjectPage;